/* @flow */

const sum = (x: number, y: number) => x + y;

export default sum;
